export const CONTACT_TYPE_BOOTHPERSONAL = 2;

export const LANGUAGE_DE = 'de';
export const LANGUAGE_EN = 'en';

// if ICS in the Backend is updated the const needs an update too (LocationFixture.cs)
export const ICS_LOCATIONS = [
  'C1 + C2',
  'C2',
  'C2.1',
  'C2.1 + C2.2',
  'C2.2',
  'C2.2 + C2.3',
  'C2.3',
  'C1',
  'C1.1',
  'C1.1.1',
  'C1.1.1+C1.2.1',
  'C1.1.2',
  'C1.1.2+C1.2.2',
  'C1.1+ C1.2.1',
  'C1.1+ C1.2.2',
  'C1.2',
  'C1.2.1',
  'C1.2.2',
  'Mittelfoyer',
  'Seitenfoyer (Süd)',
  'Foyer C1 + C2',
  'Foyer C1',
  'Foyer C2',
  'Freigelände ICS',
  'Funktionsfläche 1',
  'Funktionsfläche 2',
  'C3.1',
  'C3.1.1',
  'C3.1.2',
  'C3.2',
  'C3.2.1',
  'C3.2.2',
  'C3.3.1',
  'C3.3.2',
  'C4',
  'C4.1',
  'C4.1.1',
  'C4.1.2',
  'C4.1 + C4.2',
  'C4.2',
  'C4.2 + C4.3',
  'C4.3',
  'C5',
  'C5.1',
  'C5.1.1',
  'TC5.1.2',
  'C5.1 + C5.2',
  'C5.2',
  'C5.2 + C5.3',
  'C5.3',
  'C6.1',
  'Foyer C6.1',
  'C6.2',
  'C6.2.1',
  'C6.2.2',
  'C7',
  'C7.1',
  'C7.1.1',
  'C7.1.2',
  'C7.1 + C7.2',
  'C7.2',
  'C7.2 + C7.3',
  'C7.3',
  'C8.1',
  'C8.1.1',
  'C8.1.2',
  'C8.2',
  'C8.2.1',
  'C8.2.2',
  'C9',
  'C9.2',
  'C9.2.1',
  'C9.2.2',
  'C9.3',
  'Foyer C9.2',
  'C10.1',
  'C10.10',
  'C10.11',
  'C10.2',
  'C10.3',
  'C10.4',
  'C10.5',
  'C10.6',
  'C10.7',
  'C10.8',
  'C10.9'
];
